// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1rPFo","content":"RecentSearches_content__2lyzz"};